import {
    GET_NOTIFICATIONS_PROGRESS, GET_NOTIFICATIONS_SUCCESS, GET_NOTIFICATIONS_FAILURE,
   
    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    notifications: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const notification_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_NOTIFICATIONS_SUCCESS:
            return { ...state, notifications: action.notifications, loading: false };
        case GET_NOTIFICATIONS_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_NOTIFICATIONS_PROGRESS:
            return { ...state, loading: true, error: false };
      
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default notification_reducer;